import { firstAccessiblePath } from "@utils/permissions";
import { useTranslation } from "react-i18next";
import { HiArrowLeft } from "react-icons/hi";
import { Link } from "react-router-dom";
import { useDocumentTitle } from "@mantine/hooks";

import { PAGE_TITLE, ROLES } from "@constants/index";

import { useAuth } from "@contexts/auth";

import { Container } from "@styles/components/Container.styled";

import ErrorIllustration from "@assets/misc/404-illustration.svg?react";

import { StyledErrorPage } from "./ErrorPage.styled";


interface ErrorPageProps {
  reason?: "missingPage" | "unauthorized";
}

export const ErrorPage = ({ reason = "missingPage" }: ErrorPageProps) => {
  const { t } = useTranslation();

  useDocumentTitle(`${t("page-not-found")} • ${PAGE_TITLE}`);

  const { permissions, token } = useAuth();

  return (
    <StyledErrorPage>
      <Container style={{ height: "100%" }}>
        <div className="content">
          <ErrorIllustration className="illustration" />
          <div className="text-content">
            {reason === "missingPage" ? (
              <>
                <h1>{t("404.missing.title")}</h1>
                <p>{t("404.missing.description")}</p>
              </>
            ) : (
              <>
                <h1>{t("404.unauthorized.title", { context: "this-page" })}</h1>
                <p>
                  {t("404.unauthorized.description", { context: "this-page" })}
                </p>
              </>
            )}
            <Link
              to={
                !token
                  ? "/"
                  : reason === "missingPage"
                  ? ".."
                  : firstAccessiblePath(permissions)
              }
              className="cta">
              <HiArrowLeft />
              <span>{t("go-back")}</span>
            </Link>
          </div>
        </div>
      </Container>
    </StyledErrorPage>
  );
};
